<template>
  <div id="app">
    <div class="page-content">
      <!-- Menü: Csak ha NEM kivétel (fullPage) -->
      <ifka-vp-navigation v-if="!isFullPage"></ifka-vp-navigation>
      <!-- Fő tartalom wrapper: Feltételes spacing -->
      <div :class="{ 'header-spacing': !isFullPage }">
        <!-- Back button: Csak ha NEM kivétel ÉS a hideBackButton logika szerint -->
        <ifka-vp-back-button v-if="!isFullPage && !hideBackButton()"></ifka-vp-back-button>
        <!-- Router view: Mindig -->
        <router-view />
        <!-- Cookie law: Csak ha NEM kivétel -->
        <ifka-vp-cookie-law v-if="!isFullPage"></ifka-vp-cookie-law>
        <!-- Exim popup: Csak ha NEM kivétel -->
        <exim-popup v-if="!isFullPage" />
      </div>
      <!-- Footer: Csak ha NEM kivétel -->
      <ifka-vp-footer v-if="!isFullPage"></ifka-vp-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BackButton from './components/BackButton.vue'
import CookieLaw from './components/CookieLaw.vue'
import EximPopup from './components/EximPopup'
import Footer from './components/Footer.vue'
import Navigation from './components/Navigation.vue'

export default {
  components: {
    ifkaVpNavigation: Navigation,
    ifkaVpCookieLaw: CookieLaw,
    ifkaVpFooter: Footer,
    ifkaVpBackButton: BackButton,
    EximPopup
  },
  computed: {
    // ÚJ: Centralizált kivételkezelés – true, ha fullPage mód (nincs menü/footer)
    isFullPage() {
      const fullPagePaths = ['/fix3kkv', '/demjansandorprogram']
      return fullPagePaths.includes(this.$route.path) || this.$route.path.startsWith('/we-circular')
    },
    adminNav: function() {
      if (this.$route.path) {
        return (
          this.$route.path.includes('/competitions') ||
          this.$route.path.includes('/users') ||
          this.$route.path.includes('/contents') ||
          this.$route.path.includes('/access-management')
        )
      }
      return false
    },
    ...mapGetters(['isAuthenticated', 'userHaveReadPermission'])
  },
  created() {
    // Cím frissítése: Mindig, meta alapján (ha van, különben 'Vali.hu')
    document.title = this.$route.meta?.title || 'Vali.hu'

    // Popup-ok: Csak ha NEM kivétel
    if (this.isFullPage) {
      return // ÚJ: Ne fusson popup a kivétel oldalon
    }

    const eximPopup = localStorage.getItem('eximPopup')
    const videoPopup = localStorage.getItem('videoPopup')

    // hardcode popup disabled
    const showPopup = false

    if (eximPopup != '1' && showPopup) {
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'exim-popup')
      }, 20000)

      localStorage.setItem('eximPopup', '1')
    }

    if (videoPopup != '1') {
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'video-popup')
      }, 1000)

      localStorage.setItem('videoPopup', '1')
    }
  },
  methods: {
    hideBackButton() {
      if (this.$route.path === '/contents') {
        return true
      }
      if (this.$route.path.includes('/fund-map/search')) {
        return true
      }
      if (this.$route.path.includes('/fund-map/fund')) {
        return true
      }
      if (this.$route.path.includes('/create-fund')) {
        return true
      }
      if (this.$route.path.includes('/fund-map/imaginary-company-details')) {
        return true
      }

      return false
    }
  },
  watch: {
    $route() {
      // ÚJ: Cím frissítése route változáskor (még kivétel esetén is)
      document.title = this.$route.meta?.title || 'Vali.hu'

      // ÚJ: Csak ha NEM kivétel, fusson a nav collapse logika
      if (this.isFullPage) {
        return
      }

      const element = document.querySelector('#nav-collapse')
      let isShown = element.classList.contains('show')
      if (isShown) {
        this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
      }
    }
  }
}
</script>

<style>
@import './assets/css/Vali2.0-core.css';
@import './assets/css/Vali2.0-nav.css';
@import './assets/css/Toaster.css';

.header-spacing {
  margin-top: 130px;
}

@media all and (max-width: 615px) {
  .header-spacing {
    margin-top: 240px;
  }
}

/* ÚJ: Kivétel esetén teljes képernyő biztosítása */
.page-content {
  min-height: 100vh; /* Alap: teljes magasság */
}

/* Opcionális: Ha kivétel, távolítsd el a felesleges stílusokat (modern CSS, kihagyható ha probléma van) */
.page-content:has(router-view) {
  padding: 0;
  margin: 0;
}
</style>
